export default __webpack_public_path__ + "static/media/m_technology.805fea70.png";